import React from "react";
import { useDispatch } from "react-redux";
import CustomMultiSelect, { CustomMultiSelectModel } from "../../../../components/CustomMultiSelect";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { Helpers } from "../../../../helpers/Helpers";
import { storeImageViewer } from "../../../../redux/reducers/authSlice";
import { ConstantService } from "../../../../services/ConstantService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    licenceInformationRef: any
    licenceSerialNumber: string | undefined
    setLicenceSerialNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    licenceDigitalNumber: string | undefined
    setLicenceDigitalNumber: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedLicenceClass: CustomMultiSelectModel[]
    setSelectedLicenceClass: React.Dispatch<React.SetStateAction<CustomMultiSelectModel[]>>
    driverRecordNo: string | undefined
    setDriverRecordNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedBloodType: CustomSingleSelectModel | undefined
    setSelectedBloodType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    givenDate: string | undefined
    setGivenDate: React.Dispatch<React.SetStateAction<string | undefined>>
    validityDate: string | undefined
    setValidityDate: React.Dispatch<React.SetStateAction<string | undefined>>
    givenPlace: string | undefined
    setGivenPlace: React.Dispatch<React.SetStateAction<string | undefined>>
    licenceFileB64: string
    licenceFileRef: any
    setLicenceFile: React.Dispatch<React.SetStateAction<File | undefined>>
    setLicenceFileB64: React.Dispatch<React.SetStateAction<string>>
    handleFileRead: (event: any, setFunction: React.Dispatch<React.SetStateAction<string>>) => Promise<void>
}

const LicenceInformation = ({
    licenceInformationRef,
    licenceSerialNumber,
    setLicenceSerialNumber,
    licenceDigitalNumber,
    setLicenceDigitalNumber,
    selectedLicenceClass,
    setSelectedLicenceClass,
    driverRecordNo,
    setDriverRecordNo,
    selectedBloodType,
    setSelectedBloodType,
    givenDate,
    setGivenDate,
    validityDate,
    setValidityDate,
    givenPlace,
    setGivenPlace,
    licenceFileB64,
    licenceFileRef,
    setLicenceFile,
    setLicenceFileB64,
    handleFileRead
}: Props) => {
    const dispatch = useDispatch();

    return (
        <div className='containerPart' ref={licenceInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Ehliyet Bilgileri</h4>

                    <div className='row'>
                        <div className="col-md-9">
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ehliyet Seri No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={licenceSerialNumber} onChange={(e) => setLicenceSerialNumber(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ehliyet Sınıfı</label>

                                        <CustomMultiSelect
                                            selectedValues={selectedLicenceClass}
                                            onChange={setSelectedLicenceClass}
                                            insertable={{
                                                onSubmit: { code: 'LICENCE_CLASS' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('LICENCE_CLASS')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Sürücü Sicil No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={driverRecordNo} onChange={(e) => setDriverRecordNo(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kan Grubu</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedBloodType}
                                            onChange={setSelectedBloodType}
                                            insertable={{
                                                onSubmit: { code: 'BLOOD_TYPE' }
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('BLOOD_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Dijital Ehliyet No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={licenceDigitalNumber} onChange={(e) => setLicenceDigitalNumber(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Veriliş Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={givenDate} onChange={(e) => setGivenDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Geçerlilik Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={validityDate} onChange={(e) => setValidityDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Verildiği Yer</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={givenPlace} onChange={(e) => setGivenPlace(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">Ehliyet Resmi</label>

                            <div>
                                <img onClick={() => dispatch(storeImageViewer([licenceFileB64]))} style={{ width: '100%' }} className="actionIcon img img-thumbnail" src={licenceFileB64} />

                                <div className='mt-5 p-3 img img-thumbnail d-flex'>
                                    <div className='d-flex flex-grow-1'>
                                        <input accept="image/*" ref={licenceFileRef} onChange={(e) => { setLicenceFile(e && e.target && e.target.files && e.target.files.length > 0 ? e.target.files[0] : undefined); handleFileRead(e, setLicenceFileB64); }} type="file" className="form-control form-control-solid" />
                                    </div>

                                    {
                                        !Helpers.isEmpty(licenceFileB64) && (
                                            <div style={{ marginLeft: 15 }} className='d-flex align-items-center'>
                                                <i onClick={() => { setLicenceFile(undefined); setLicenceFileB64(Helpers.getPlaceholder()); licenceFileRef.current.value = ""; }} style={{ fontSize: 18 }} className='actionIcon text-danger fa fa-trash' />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default LicenceInformation;